import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgTrafalgarClassFleetSubmarine = function ({
  size = 16,
  ...props
}: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 41"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M80.2 0c.457 0 1.105.116 1.898.324q.416.109.865.244.462.14.907.29l.483.166.306.11c.033.012.056.04.065.072l.003.025v4.987l.079.044c.286.17.472.402.515.662l.007.056.003.06c0 .291-.176.553-.474.747l-.13.076v5.323h47.285c15.228 0 29.978 2.052 43.887 5.576l1.216.313q.024.006.04.02l.02-.002.023.003.566.148a.1.1 0 0 1 .077.097l2.258.64.104-1.898 9.845 1-.069 3.87.668.198.076-2.048 6.635 1.48.032 3.15 2.61 1.204v.938l-2.642 1.131.032 2.947-6.644 1.5-.023-2.115-.89.378.092 8.084q-4.167 1.443-9.342 0l-.38-5.069-10.073 2.39c-1.962.442-5.87 1.156-13.806 1.081l-2.16-.028q-13.298-.138-103.273.086-18.687.3-31.534-1.775l-4.64-.771C5.134 34.143 3.31 33.945 1.59 31.716-.34 29.212.226 25.795.3 25.417c.073-.377 1.315-3.622 1.667-3.992.35-.37.765-1.21 2.23-1.746l.336-.116a30 30 0 0 1 1.747-.492l.361-.12c2.348-.762 6.082-1.658 10.927-2.498l1.094-.185.753-.123 1.535-.24c7-1.058 15.229-1.859 24.724-2.31l1.595-.071.977-.041v-2.317c0-.476.43-1.276.88-1.38l.048-.007.046-.003h.615c.465 0 .947.828.978 1.34l.002.05v2.223l.79-.025a392 392 0 0 1 8.405-.162l2.669-.015 1.117-.001V1.853l.004-.142c.05-1.259.583-1.63 2.566-1.699l.46-.01.368-.002z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgTrafalgarClassFleetSubmarine
